// extracted by mini-css-extract-plugin
module.exports = {"item":"publicationitem-module--item--1Dd0K"};